// sagas/innerCircleSaga.js
import { put, call, takeLatest } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import {
  innerCircleLoad,
  innerCircleSuccess,
  innerCircleFail,
  createActivityLoad,
  createActivitySuccess,
  createActivityFail,
  createInnerCircleLoad,
  createInnerCircleSuccess,
  createInnerCircleFail,
  innerCircleDetailLoad,
  innerCircleDetailSuccess,
  innerCircleDetailFail,
  addUserinCircleLoad,
  addUserinCircleSuccess,
  addUserinCircleFail,
  addUserCircleLoad,
  addUserCircleSuccess,
  addUserCircleFail,
  getCircleListLoad,
  getCircleListSuccess,
  getCircleListFail,
  getCommentListLoad,
  getCommentListSuccess,
  getCommentListFail,
  innerCircleGlobalListLoad,
  innerCircleGlobalListFail,
  innerCircleGlobalListSuccess,
  deleteCircleLoad,
  deleteCircleSuccess,
  editCircleLoad,
  editCircleSuccess
} from "../slices/inner.slice";

import {
  addUserApi,
  addUserInCircleApi,
  getCirclePostListAPI,
  createInnerCircleApi,
  innerCircleApi,
  innerCircleDetailApi,
  getCommentListApi,
  innerCircleGloabListApi,
  deleteCircleApi,
  editCircleApi
} from "../Api/api";

function* innerCircleSaga(action) {
  try {
    const data = yield call(innerCircleApi, action.payload);
    if (data.status === 0) {
      yield put(innerCircleSuccess(data.result.data));
    } else {
      yield put(innerCircleFail());
    }
  } catch (e) {
    console.error("Inner circle saga error:", e);
    yield put(innerCircleFail());
  }
}

function* addUserSaga(action) {
  try {
    let data = yield call(addUserApi, action.payload);
    if (data.status === 0) {
      yield put(addUserCircleSuccess(data.result.data));
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
    } else {
      yield put(addUserCircleFail());
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
    }
  } catch (error) {
    yield put(addUserCircleFail());
    toast.error("Failed to add user", { position: "top-right", autoClose: 3000 });
  }
}

function* createInnerCircleSaga(action) {
  try {
    let data = yield call(createInnerCircleApi, action.payload);
    if (data.status === 0) {
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
      yield put(createInnerCircleSuccess(data.result.data));
    } else {
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
      yield put(createInnerCircleFail());
    }
  } catch {
    toast.error("Failed to create inner circle", { position: "top-right", autoClose: 3000 });
    yield put(createInnerCircleFail());
  }
}

function* innerCircleDetailSaga(action) {
  try {
    let data = yield call(innerCircleDetailApi, action.payload);
    if (data.status == 0) {
      yield put(innerCircleDetailSuccess(data.result.data));
    } else {
      yield put(innerCircleDetailFail());
    }
  } catch {
    yield put(innerCircleDetailFail());
  }
}

function* addUserCircleSaga(action) {
  try {
    let data = yield call(addUserInCircleApi, action.payload);
    if (data.status == 0) {
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
      yield put(addUserinCircleSuccess());
    } else {
      yield put(addUserinCircleFail());
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
    }
  } catch {
    yield put(addUserinCircleFail());

    toast.error("Failed to add user to circle", { position: "top-right", autoClose: 3000 });
  }
}

function* getCirclePostListSaga(action) {
  try {
    let data = yield call(getCirclePostListAPI, action.payload);
    if (data.status === 0) {
      yield put(getCircleListSuccess(data.result.data));
    } else {
      yield put(getCircleListFail());
    }
  } catch {
    yield put(getCircleListFail());
  }
}

function* getCommentListSaga(action) {
  try {
    let data = yield call(getCommentListApi, action.payload);
    if (data.status === 0) {
      yield put(getCommentListSuccess(data.result.data));
    } else {
      yield put(getCommentListFail());
    }
  } catch {
    yield put(getCommentListFail());
  }
}

function* innerCircleGlobalListSaga(action) {
  try {
    let data = yield call(innerCircleGloabListApi, action.payload);
    if (data.status === 0) {
      yield put(innerCircleGlobalListSuccess(data.result.data));
    } else {
      yield put(innerCircleGlobalListFail());
    }
  } catch {
    yield put(innerCircleGlobalListFail());
  }
}

function* deleteCircleSaga(action) {
  try {
    let data = yield call(deleteCircleApi, action.payload);
    if (data.status === 0) {
      yield put(deleteCircleSuccess(data.result.data));
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
    } else {
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
    }
  } catch {



  }
}

function* editCircleSaga(action) {
  try {
    let data = yield call(editCircleApi, action.payload);
    if (data.status === 0) {
      yield put(editCircleSuccess());
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
    } else {
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
    }
  } catch {


  }
}




export default function* rootInnerCircleSaga() {
  yield takeLatest(innerCircleLoad.type, innerCircleSaga);
  yield takeLatest(addUserCircleLoad.type, addUserSaga);
  yield takeLatest(createInnerCircleLoad.type, createInnerCircleSaga);
  yield takeLatest(innerCircleDetailLoad.type, innerCircleDetailSaga);
  yield takeLatest(addUserinCircleLoad.type, addUserCircleSaga);
  yield takeLatest(getCircleListLoad.type, getCirclePostListSaga);
  yield takeLatest(getCommentListLoad.type, getCommentListSaga);
  yield takeLatest(innerCircleGlobalListLoad.type, innerCircleGlobalListSaga);
  yield takeLatest(deleteCircleLoad.type, deleteCircleSaga);
  yield takeLatest(editCircleLoad.type, editCircleSaga);
}
